import React from 'react';
import AddOrEditBuyerForm from './AddOrEditBuyerForm';

/* React functional component */
const CreateBuyerScreen = () => {
  return <AddOrEditBuyerForm mode="add" />;
};

export default CreateBuyerScreen;
